// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isIntegrationsCurrentsIntegrationsConfigResult = objectOf({
  api_request_processing_status_supported_destinations: maybe(arrayOf(string)),
  eventbridge: objectOf({
    allowed_regions: arrayOf(
      objectOf({
        region: string,
        label: string,
      })
    ),
  }),
});
